var map = {
	"./analysis.svg": 3773,
	"./arrow-active.svg": 3405,
	"./arrow.svg": 7190,
	"./check-none.svg": 2240,
	"./check.svg": 2497,
	"./close.svg": 5837,
	"./data-source.svg": 3851,
	"./doc.svg": 1075,
	"./edit.svg": 975,
	"./file.svg": 4709,
	"./folder.svg": 811,
	"./frame.svg": 8174,
	"./history.svg": 3185,
	"./home.svg": 4174,
	"./ipt/arrow-right.png": 8263,
	"./ipt/arrow.svg": 4902,
	"./ipt/circle.svg": 7455,
	"./ipt/go-arrow.svg": 9681,
	"./ipt/ipt.svg": 3716,
	"./ipt/kwd.png": 51,
	"./ipt/setting.svg": 3285,
	"./ipt/sfa.png": 7565,
	"./ipt/xyd.png": 2514,
	"./menu-fold.svg": 1666,
	"./next.svg": 2396,
	"./pause.svg": 1947,
	"./play.svg": 757,
	"./prev.svg": 5724,
	"./process.svg": 9642,
	"./progress-active.svg": 2013,
	"./progress.svg": 6454,
	"./question-nav.svg": 3571,
	"./question.svg": 4515,
	"./remind.svg": 6564,
	"./steps/left-active.svg": 8979,
	"./steps/left.svg": 2496,
	"./steps/normal-active.svg": 117,
	"./steps/normal.svg": 5998,
	"./steps/right-active.svg": 5822,
	"./steps/right.svg": 2175,
	"./suggest.svg": 5883,
	"./trans.svg": 655,
	"./user.svg": 698,
	"./vector.svg": 2938,
	"./voice.svg": 591,
	"./writing/add.svg": 7085,
	"./writing/ai-active.svg": 1525,
	"./writing/ai.svg": 2750,
	"./writing/backtop.svg": 6490,
	"./writing/bianji-active.svg": 3924,
	"./writing/bianji.svg": 5321,
	"./writing/comment1.svg": 5328,
	"./writing/comment2.svg": 9987,
	"./writing/comment3.svg": 2610,
	"./writing/like-active.svg": 6216,
	"./writing/like.svg": 1317,
	"./writing/meeting.svg": 3079,
	"./writing/plan1.svg": 862,
	"./writing/plan2.svg": 9981,
	"./writing/plan3.svg": 268,
	"./writing/refresh-active.svg": 3824,
	"./writing/refresh.svg": 445,
	"./writing/runse-active.svg": 3482,
	"./writing/runse.svg": 7843,
	"./writing/send.svg": 3014,
	"./writing/slider.svg": 427,
	"./writing/stop.svg": 5068,
	"./writing/technical.svg": 7725,
	"./writing/volum.svg": 2277,
	"./writing/zan-active.svg": 726,
	"./writing/zan.svg": 9575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8821;